
import { supabase } from '@/integrations/supabase/client';

export const useDataAgentOperations = () => {
  const fetchDataAgentData = async (action: string, params?: any) => {
    try {
      const response = await supabase.functions.invoke('data-agent', {
        body: JSON.stringify({ action, params })
      });
      return response.data;
    } catch (error) {
      console.error(`Data Agent fetch error for ${action}:`, error);
      throw error;
    }
  };

  return { fetchDataAgentData };
};
